import { render, staticRenderFns } from "./ELearningDashboard.vue?vue&type=template&id=449da5e9&scoped=true"
import script from "./ELearningDashboard.vue?vue&type=script&lang=js"
export * from "./ELearningDashboard.vue?vue&type=script&lang=js"
import style0 from "./ELearningDashboard.vue?vue&type=style&index=0&id=449da5e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449da5e9",
  null
  
)

export default component.exports